<div class="selection-modal">
  <div class="header-row">
      <span class="header-title">{{title}}</span>
      <button mat-icon-button (click)="closeModal()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="content">
    <mat-selection-list #itmList>
      <mat-list-option *ngFor="let item of data.list" [value]="item.name" [selected]="item.selected">{{item.name}}</mat-list-option>
    </mat-selection-list>
  </div>
  <div class="actions-row">
    <button mat-raised-button class="osc-button osc-button--primary save-button" (click)="updateSelection()">Save</button>
    <button mat-raised-button class="osc-button osc-button--secondary" (click)="resetSelection()">Reset</button>
    <button mat-raised-button class="osc-button osc-button--secondary" (click)="closeModal()">Cancel</button>
  </div>
</div>